import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-221">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-222" />

      {/* Panel */}
      <div className="relative z-10 w-full max-w-2xl max-h-[80vh] bg-[#0a1520] border border-[#c9a84c]/30 rounded-lg shadow-[0_0_60px_rgba(0,0,0,0.8)] flex flex-col overflow-hidden" data-id="element-223">
        {/* Header */}
        <div className="flex items-center justify-between px-8 py-5 border-b border-[#c8c0b0]/10 flex-shrink-0" data-id="element-224">
          <div data-id="element-225">
            <span className="block text-[#00d4ff] font-mono text-xs tracking-widest mb-1" data-id="element-226">
              SYSTEM DOCUMENT
            </span>
            <h2 id="modal-title" className="text-xl font-bold text-[#c8c0b0]" style={{
            fontFamily: 'Cinzel, serif'
          }} data-id="element-227">
              {title}
            </h2>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center text-[#c8c0b0]/50 hover:text-[#00d4ff] border border-[#c8c0b0]/10 hover:border-[#00d4ff]/50 rounded transition-colors duration-200" aria-label="Close" data-id="element-228">
            <X className="w-4 h-4" data-id="element-229" />
          </button>
        </div>

        {/* Scrollable Content */}
        <div className="overflow-y-auto px-8 py-6 text-[#c8c0b0]/70 text-sm leading-relaxed space-y-4 flex-1" data-id="element-230">
          {children}
        </div>

        {/* Footer */}
        <div className="px-8 py-4 border-t border-[#c8c0b0]/10 flex-shrink-0" data-id="element-231">
          <button onClick={onClose} className="w-full py-2 text-xs font-mono tracking-widest text-[#c8c0b0]/40 hover:text-[#00d4ff] transition-colors duration-200" data-id="element-232">
            [ CLOSE DOCUMENT ]
          </button>
        </div>
      </div>
    </div>;
}